// import {http} from "@/cbd-migration/importSettings";
// import HttpHandler from "@/handler/HttpHandler";
import http from '@/util/http';
import LoginThirdPart from "@/login/LoginThirdPart";

// const http = new HttpHandler();

// 登录方法
export function loginTicket(userType, ticket, appCode, clientId, username) {
  const data = { userType, ticket, appCode, clientId };
  // username + ticket 免登录时才传 username，不影响原单点登录流程
  if (username) {
    data.username = username;
  }
  return http.post("/aaas-auth/loginTicket", data);
}

export function getInfo() {
  return http.get("/aaas-auth/getInfo");
}
export function createToken(accountId,key) {
  return http.get(`/aaas-auth/createToken?accountId=${accountId}&key=${key}`);
}

export function logout() {
  return http.get("/aaas-auth/logout").then(() => {
    LoginThirdPart.logout()
  });
}

export default {
  loginTicket,
  getInfo,
  logout,
  createToken
}
